import styled from "styled-components";

export const LoginFormStyled = styled.div`
  margin: auto;
  width: 100%;
  .login_header {
    margin-bottom: 40px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
  }
  .input_wrap {
    margin-bottom: 15px;
  }
  .btn_wrap {
    margin-top: 40px;
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.MOBILE}) {
    .login_header {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
`;
